// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"23":"13d79c44","70":"0fd0af24","118":"8d5cd747","517":"c4dc59be","525":"bce792b3","548":"44afdff9","564":"d0fa393a","691":"f25be6c3","835":"6846499d","958":"46899564"}[chunkId] + ".chunk.js";
};